import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowDown2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    fillRule="evenodd"
    clipRule="evenodd"
    imageRendering="optimizeQuality"
    shapeRendering="geometricPrecision"
    textRendering="geometricPrecision"
    viewBox="0 0 186.26 186.26"
    {...props}
  >
    <path
      fillRule="nonzero"
      d="m23.98 43.07 69.18 69.2 69.12-69.2 15.52 15.41-84.64 84.72-84.7-84.72z"
      className="fil0"
    />
  </svg>
);
export default SvgArrowDown2;
